var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-layout",
    {
      attrs: {
        title: _vm.Resources.BackerCenter.SectionYourDashboardHeader,
        "current-view": "dashboard",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "_grid _grid-cols-1 _grid-cols-16--m _gap-4 _gap-6--m _pt-4 _pt-6--m",
        },
        [
          _c("backer-center-pending-actions-slider", {
            staticClass: "_col-span-16--m",
            attrs: { "data-qa": "section:BackerCenterPendingActionsSlider" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_flexcol _gap-4 _gap-6--m _col-span-9--m" },
            _vm._l(_vm.mainColumn, function (component) {
              return _c(component, {
                key: component,
                tag: "component",
                attrs: { "data-qa": `section:${component}` },
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.sideColumn.length
            ? _c(
                "div",
                { staticClass: "_flexcol _gap-4 _gap-6--m _col-span-7--m" },
                _vm._l(_vm.sideColumn, function (component) {
                  return _c(component, {
                    key: component,
                    tag: "component",
                    attrs: { "data-qa": `section:${component}` },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("backer-center-project-recommendations-section", {
            staticClass: "_col-span-16--m",
            attrs: {
              "extra-large-screen-visible-items-count": 4,
              "data-qa": `section:BackerCenterProjectRecommendationsSection`,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }